import jquery from 'jquery';

const $ = jquery;

/**
 * isInViewport
 * @param {Object} options Optional values for top and bottom offsets
 * @returns {Boolean} True if the element is in the viewport, false otherwise or
 * if the element does not exist in the document.
 */
$.fn.isInViewport = function (options) { // This is the easiest way to have default options.
    const settings = $.extend({
        topOffset: 0,
        bottomOffset: 0,
    }, options);

    if (!$(this).length) {
        return false;
    }

    const elementTop = $(this).offset().top - settings.topOffset;
    const elementBottom = elementTop + $(this).outerHeight() + settings.bottomOffset;
    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

// Fn to allow an event to fire after all images are loaded
$.fn.imagesLoaded = function () {
    // get all the images (excluding those with no src attribute)
    const $imgs = this.find('img[src!=""]');
    // if there's no images, just return an already resolved promise
    // eslint-disable-next-line new-cap
    if (!$imgs.length) { return $.Deferred().resolve().promise(); }

    // for each image, add a deferred object to the array which resolves when the image is loaded (or if loading fails)
    const dfds = [];
    $imgs.each(function () {
        // eslint-disable-next-line new-cap
        const dfd = $.Deferred();
        dfds.push(dfd);
        const img = new Image();
        img.onload = function () { dfd.resolve(); };
        img.onerror = function () { dfd.resolve(); };
        img.src = this.src;
    });

    // return a master promise object which will resolve when all the deferred objects have resolved
    // IE - when all the images are loaded
    return $.when(...dfds);
};

window.jQuery = $;
window.$ = $;
